import CommonApp from '../../app.js';
import {strings} from '../../../util/strings.js';
import intlPhoneTemplate from './intl-phone.html';

CommonApp.module.service('strings', function() {
    return strings;
});

CommonApp.module.directive('nsIntlPhone',
    ['phoneDetailsFactory', 'strings', function(phoneDetailsFactory, strings) {
        return {
            restrict: 'E',
            template: intlPhoneTemplate,
            scope: {
                isFocused: '<',
                phoneEmpty: '<',
                phone: '=',
                phoneCode: '=',
                isSubmitted: '<',
                selectedCountry: '<',
                defaultCountry: '<',
                isRequired: '<'
            },
            link: function(scope, element, attrs) {
                scope.isFocused = scope.isFocused || false;
                scope.phoneEmpty = scope.phoneEmpty || true;
                scope.phoneCode = scope.phoneCode || scope.defaultCountry;
                scope.isSubmitted = scope.isSubmitted || false;
                scope.isRequired = scope.isRequired || false;

                scope.phoneRequired = strings.get('tdc_phoneRequired');
                scope.phoneInvalid = strings.get('tdc_phoneInvalid');

                scope.countryList = phoneDetailsFactory.getCountryList();
                scope.selectedCountry = scope.countryList[scope.phoneCode];

                var init = Object.values(scope.countryList);
                scope.phoneInit = init.map(function(x) {
                    return x.countryName;
                }).indexOf(scope.selectedCountry.countryName);

                scope.$watch('phone', function(newValue) {
                    scope.phone = newValue;

                    if (!scope.phone || scope.phone === '') {
                        scope.phoneEmpty = true;
                    } else {
                        scope.phoneEmpty = false;
                    }
                });

                scope.$watch('phoneCode', function(newValue) {
                    scope.phoneCode = newValue;
                    scope.selectedCountry = scope.countryList[newValue];
                });

                scope.countrySelect = function(newValue) {
                    scope.phoneCode = newValue;
                    scope.selectedCountry = scope.countryList[newValue];
                };

                scope.onBlur = function() {
                    /*
                        ACCT-935: setTimeout will trigger an Angular digest cycle to update the view.
                        The timeout interval is 0, so that the trigger happens
                        right after the current digest cycle is done.
                    */
                    setTimeout(function() {
                        scope.$apply(function() {
                            var el = document.getElementsByName('phoneform');
                            if (angular.element(el).has(document.activeElement).length) {
                                scope.isFocused = true;
                            } else {
                                scope.isFocused = false;
                            }
                            if (!scope.phone || scope.phone === '') {
                                scope.phoneEmpty = true;
                            } else {
                                scope.phoneEmpty = false;
                            }
                        });
                    }, 0);
                    setTimeout(function() {
                        if (scope.isFocused) {
                            angular.element(document.getElementsByName('phoneinput')).focus();
                        } else {
                            scope.phoneform.phoneinput.$setValidity('empty', !scope.phoneEmpty);
                        }
                    }, 0);
                };

                scope.onFocus = function() {
                    setTimeout(function() {
                        scope.isFocused = true;
                        scope.phoneform.phoneinput.$setUntouched();
                    }, 0);
                };
            }
        };
    }]);



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/intl-phone/intl-phone.js
// module id = 254
// module chunks = 0